import _wrapRegExp from "@babel/runtime/helpers/wrapRegExp";
import { __decorate } from "tslib";
import { wujiRequest } from "../../core/common/wujiRequest";
import { State } from 'vue-class-state';
const UrlPattern = /*#__PURE__*/_wrapRegExp(/(\w+)\/([\w-]+)\/(\w+)\/(batch\/)?(\w+)$/, {
  projectId: 1,
  pageId: 2,
  collectionId: 3,
  cgiId: 5
});
const TargetEnvId = 'dev';
export default class LogHandler {
  constructor() {
    this.display = false;
    this.datasourceLog = [];
    this.ttlms = 0; // log life time in millisec
  }

  logList() {
    const currTime = Date.now();
    for (let i = this.datasourceLog.length - 1; i >= 0; i--) {
      const log = this.datasourceLog[i];
      if (currTime - log.timestamp > this.ttlms) {
        log.isExpired = true;
      } else break;
    }
    return this.datasourceLog;
  }
  async getLogDetail(logId, projectId) {
    const url = '/api/xy/datasource/devlog/collection';
    const params = {
      url,
      method: 'get',
      params: {
        seqId: logId,
        projectid: projectId
      }
    };
    return await wujiRequest(params);
  }
  append(log) {
    this.datasourceLog.unshift(log);
  }
}
__decorate([State], LogHandler.prototype, "display", void 0);
//# sourceMappingURL=LogHandler.js.map
